import React from 'react';

const DualRings = ({
  outerRadius,
  outerStroke,
  innerRadius,
  innerStroke,
  innerProgress,
  innerColor,
  time,
  outerSegments,
  fontSize = 40,
}) => {
  const center = outerRadius;
  const outerNormalizedRadius = outerRadius - outerStroke * 2;
  const outerCircumference = outerNormalizedRadius * 2 * Math.PI;

  const innerNormalizedRadius = innerRadius - innerStroke * 2;
  const innerCircumference = innerNormalizedRadius * 2 * Math.PI;
  //const innerStrokeDashoffset = innerCircumference - (innerProgress / 100) * innerCircumference;
  const innerStrokeDashoffset = (1 - innerProgress / 100) * innerCircumference;

  let startOffset = 0;

  return (
    <svg width={outerRadius * 2} height={outerRadius * 2} viewBox={`0 0 ${outerRadius * 2} ${outerRadius * 2}`} xmlns="http://www.w3.org/2000/svg" version="1.1" style={{ maxWidth: '100%', maxHeight: '100%', flexShrink: 1, minHeight: 0, minWidth: 0 }}>
      {/* Outer ring - multicolored segments */}
      {outerSegments && outerSegments.map(function (seg, index) {
        const length = (seg.progress / 100) * outerCircumference;
        const dashArray = length + ' ' + (outerCircumference - length);
        const dashOffset = startOffset;
        startOffset += length;

        return (
          <circle
            key={index}
            stroke={seg.color}
            fill="transparent"
            strokeWidth={outerStroke}
            strokeDasharray={dashArray}
            strokeDashoffset={-dashOffset}
            r={outerNormalizedRadius}
            cx={center}
            cy={center}
            transform={'rotate(-90 ' + center + ' ' + center + ')'}
          />
        );
      })}

      {/* Inner ring - current exercise */}
      <circle
        stroke="#e6e6e6"
        fill="transparent"
        strokeWidth={innerStroke}
        r={innerNormalizedRadius}
        cx={center}
        cy={center}
      />
      <circle
        stroke={innerColor}
        fill="transparent"
        strokeWidth={innerStroke}
        strokeDasharray={innerCircumference}
        strokeDashoffset={-innerStrokeDashoffset}
        r={innerNormalizedRadius}
        cx={center}
        cy={center}
        transform={'rotate(-90 ' + center + ' ' + center + ')'}
      />

      {/* Center time text */}
      <text
        x="50%"
        y="50%"
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize={fontSize}
        fontFamily="monospace"
        fill="black" //"#007BFF"         // fixed blue color
        fontWeight="bold"      // bold text
        style={{ userSelect: 'none' }}
      >
        {time}
      </text>
    </svg>
  );
};

export default DualRings;
